/* OBEN: cash-on-delivery order form → prefilled Shopify checkout, plus sticky mobile bar */
(function () {
  'use strict';
  if (window.__obenOrder) return;
  window.__obenOrder = true;

  var PREFIX = { AL: '355', XK: '383', MK: '389' };
  var VALID = {
    AL: /^3556[6-9]\d{7}$/, // 06X XXX XXXX
    XK: /^3834[3-9]\d{6}$/, // 04X XXX XXX
    MK: /^3897\d{7}$/, // 07X XXX XXX
  };

  function countryOf(p) {
    for (var c in VALID) if (VALID[c].test(p)) return c;
    return null;
  }

  // Normalise to international digits without "+". Accepts local (06…), 00355… and +355… forms.
  function normalizePhone(raw, country) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.indexOf('00') === 0) d = d.slice(2);
    if (/^(355|383|389)/.test(d)) return d;
    if (d.charAt(0) === '0') d = d.slice(1);
    var guess = PREFIX[country] + d;
    if (countryOf(guess)) return guess;
    // Wrong country picked but the number clearly belongs to another one: accept it.
    for (var c in PREFIX) if (countryOf(PREFIX[c] + d)) return PREFIX[c] + d;
    return guess;
  }

  function setError(form, field, msg) {
    var input = form.querySelector('[name="' + field + '"]');
    var err = form.querySelector('[data-err="' + field + '"]');
    if (input) input.setAttribute('aria-invalid', msg ? 'true' : 'false');
    if (err) err.textContent = msg || '';
  }

  function selected(root) {
    return root.querySelector('.ob-offer input:checked');
  }

  function sync(root) {
    var input = selected(root);
    if (!input) return;
    var t = root.querySelector('[data-ob-total]');
    if (t) t.textContent = input.dataset.priceLabel;
  }

  function checkoutUrl(variantId, qty, data, source) {
    var parts = data.name.trim().split(/\s+/);
    var first = parts.shift() || '';
    var last = parts.join(' ') || first;
    var country = countryOf(data.phone) || 'AL';
    var q = [
      ['checkout[shipping_address][first_name]', first],
      ['checkout[shipping_address][last_name]', last],
      ['checkout[shipping_address][address1]', data.address],
      ['checkout[shipping_address][city]', data.city],
      ['checkout[shipping_address][country]', country],
      ['checkout[shipping_address][phone]', '+' + data.phone],
      ['checkout[phone]', '+' + data.phone],
      ['attributes[Telefoni]', '+' + data.phone],
      ['attributes[Burimi]', source],
      ['note', 'Porosi COD nga faqja (' + source + ')'],
    ];
    var params = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'].forEach(function (k) {
      if (params.get(k)) q.push(['attributes[' + k + ']', params.get(k)]);
    });
    return '/cart/' + variantId + ':' + qty + '?' + q.map(function (p) {
      return encodeURIComponent(p[0]) + '=' + encodeURIComponent(p[1]);
    }).join('&');
  }

  function init(root) {
    var form = root.querySelector('[data-ob-form]');
    root.addEventListener('change', function (e) {
      if (e.target.matches('.ob-offer input')) sync(root);
      if (e.target.matches('[data-ob-country]')) {
        var ph = root.querySelector('[name="phone"]');
        if (ph) ph.placeholder = ph.dataset['ph' + e.target.value.charAt(0) + e.target.value.charAt(1).toLowerCase()] || ph.placeholder;
      }
    });
    sync(root);
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var val = function (n) { return form.querySelector('[name="' + n + '"]').value.trim(); };
      var data = {
        name: val('name'),
        phone: normalizePhone(val('phone'), val('country')),
        city: val('city'),
        address: val('address'),
      };
      var ok = true;
      if (data.name.length < 3) { setError(form, 'name', form.dataset.errName); ok = false; } else setError(form, 'name');
      if (!countryOf(data.phone)) { setError(form, 'phone', form.dataset.errPhone); ok = false; } else setError(form, 'phone');
      if (data.city.length < 2) { setError(form, 'city', form.dataset.errCity); ok = false; } else setError(form, 'city');
      if (data.address.length < 4) { setError(form, 'address', form.dataset.errAddress); ok = false; } else setError(form, 'address');
      if (!ok) {
        var bad = form.querySelector('[aria-invalid="true"]');
        if (bad) bad.focus();
        return;
      }
      var input = selected(root);
      if (!input) return;
      var btn = form.querySelector('[data-ob-submit]');
      if (btn) btn.disabled = true;

      if (typeof window.fbq === 'function') {
        window.fbq('track', 'InitiateCheckout', {
          value: Number(input.dataset.price) / 100,
          currency: 'ALL',
          content_ids: [root.dataset.variant],
          content_type: 'product',
          num_items: Number(input.value),
        });
      }
      window.location.href = checkoutUrl(root.dataset.variant, input.value, data, root.dataset.source || 'produkti');
    });
  }

  function initSticky(bar) {
    var target = document.getElementById(bar.dataset.target);
    if (!target || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var visible = true;
    function update() { bar.classList.toggle('is-visible', !visible && window.scrollY > 400); }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { visible = e.isIntersecting; update(); });
    }).observe(target);
    window.addEventListener('scroll', update, { passive: true });
    bar.querySelector('a').addEventListener('click', function (ev) {
      ev.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function boot() {
    document.querySelectorAll('[data-ob-order]').forEach(init);
    document.querySelectorAll('[data-ob-sticky]').forEach(initSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme editor: re-init sections when they are re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ob-order]').forEach(init);
    e.target.querySelectorAll('[data-ob-sticky]').forEach(initSticky);
  });
})();
